import { createContext, useCallback, useContext, useState } from "react";

import { trackEvent } from "utils";

import { ThumbtackModal } from "./thumbtack-modal";

/** Optional Mixpanel context when opening the Thumbtack discovery modal from inspection write-outs. */
export type ThumbtackModalOpenTracking = {
  referralId?: string;
  category?: string | null;
  searchTerm?: string | null;
};

const ThumbtackModalContext = createContext({
  openThumbtackModal: (
    _zipCode: string,
    _cat: string,
    _actionDescription?: string,
    _tracking?: ThumbtackModalOpenTracking,
  ) => {},
});

export function useThumbtackModalContext() {
  const ctx = useContext(ThumbtackModalContext);
  if (!ctx) {
    throw new Error(
      "useThumbtackModalContext must be used within ThumbtackModalProvider",
    );
  }
  return ctx;
}

export const ThumbtackModalProvider = ({ children }) => {
  const [zip, setZip] = useState<string>();
  const [category, setCategory] = useState<string>();
  const [action, setAction] = useState<string>();
  const [show, setShow] = useState(false);
  const openThumbtackModal = useCallback(
    (
      zipCode: string,
      cat: string,
      actionDescription?: string,
      tracking?: ThumbtackModalOpenTracking,
    ) => {
      setZip(zipCode);
      setCategory(cat);
      setAction(actionDescription);
      setShow(true);
      if (tracking !== undefined) {
        trackEvent("Inspection write-out: Thumbtack modal opened", {
          referralId: tracking.referralId,
          category: tracking.category,
          searchTerm: tracking.searchTerm,
        });
      }
    },
    [],
  );
  return (
    <ThumbtackModalContext.Provider value={{ openThumbtackModal }}>
      {children}
      <ThumbtackModal
        zipCode={zip ?? ""}
        category={category ?? ""}
        action={action}
        onClose={() => {
          setZip(undefined);
          setCategory(undefined);
          setShow(false);
        }}
        show={show}
      />
    </ThumbtackModalContext.Provider>
  );
};
